import React from "react";

const Unauthorized = () => {
    return <>401 Unauthorized Access</>
};

export default Unauthorized;